var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-path-outer",
    fill: "#757575",
    fillRule: "nonzero",
    d: "M.746 3.835H12.09a.629.629 0 0 0 0-1.255H9.975A3.79 3.79 0 0 0 6.418.07a3.787 3.787 0 0 0-3.466 2.257v.002c-.036.083-.064.167-.094.25H.746a.629.629 0 1 0 0 1.256zm5.672-2.51c.917 0 1.737.498 2.18 1.255H4.24a2.523 2.523 0 0 1 2.178-1.254zm5.673 3.766H.746a.627.627 0 1 0 0 1.254v11.92c0 .347.282.628.63.628h10.086c.346 0 .629-.28.629-.627V6.345a.627.627 0 0 0 0-1.254zM2.007 17.638V6.345h8.824v11.293H2.007zm1.26-1.882a.63.63 0 0 0 .63.628.63.63 0 0 0 .631-.628V8.228a.629.629 0 0 0-.63-.628c-.35 0-.631.281-.631.628v7.528zm2.522 0a.629.629 0 0 0 1.26 0V8.228a.629.629 0 0 0-1.26 0v7.528zm2.521 0a.629.629 0 0 0 1.26 0V8.228a.629.629 0 0 0-1.26 0v7.528z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trash-can.9fbbe42db03f32d43f6169ff0bb87e3b.svg";
export { ForwardRef as ReactComponent };